import TableContainer from '@mui/material/TableContainer';
import type { TableContainerProps } from '@mui/material/TableContainer';
import * as React from 'react';

const MUITableContainer = React.forwardRef<any, TableContainerProps>(
  ({ children, ...props }, ref) => (
    <TableContainer ref={ref} {...props}>
      {children}
    </TableContainer>
  ),
);

export default MUITableContainer;
